import sensors from 'sa-sdk-javascript/sensorsdata.es6.min.js'
import pageleave from 'sa-sdk-javascript/dist/web/plugin/pageleave/index.es6.js'
import pageload from 'sa-sdk-javascript/dist/web/plugin/pageload/index.es6.js'
import sessionEvent from 'sa-sdk-javascript/dist/web/plugin/session-event/index.es6.js'
import wechatWebviewChannel from 'sa-sdk-javascript/dist/web/plugin/wechat-webview-channel/index.js'
import rgp from 'sa-sdk-javascript/dist/web/plugin/register-properties/index.es6'
import rmNull from 'bjxy-common/helper/rmNull'

const isDev = !(['prod', 'prepub'].includes(process.env.VUE_APP_MODE))
const islocalDev = ['dev', 'mock'].includes(process.env.VUE_APP_MODE)
const server_url = isDev ? 'https://sc.yingzhongtong.com/sa?project=default' : 'https://sc.xiaoying.com/sa?project=production'
export class Track {
  constructor (options, plugins = []) {
    this.time = 0
    this.popupTime = 0
    this.cache = {}
    this.pageCache = {}
    this.sensors = sensors
    this.init(options)
    this.registerPlugin(plugins)
  }

  init (options) {
    this.sensors.init(Object.assign({
      show_log: islocalDev, // 调试log
      server_url,
      app_js_bridge: true, // 默认情况下，只有 App 数据接收地址与 H5 相同时，才可以打通成功
      is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
      use_client_time: true, // 使用客户端时间
      heatmap: {
        // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
        clickmap: 'default',
        // 是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
        scroll_notice_map: 'default',
        collect_tags: {
          div: true // 配置是否开启 div 的全埋点采集，默认不采集
        }
      },
      send_type: 'beacon', // 如果检测到浏览器不支持 beacon 时，会自动降级为使用 img 发送数据
      // batch_send: false, // 关闭批量发送
      batch_send: {
        datasend_timeout: 3000, // 一次请求超过多少毫秒的话自动取消，防止请求无响应。
        send_interval: 5000, // 间隔多少毫秒发一次数据。
        storage_length: 5 // 存储 localStorage 条数最大值，默认：200 。如 localStorage 条数超过该值，则使用 image 方式立即发送数据。v1.24.8 以上支持。
      }
    }, options))
  }

  registerPlugin (plugins) {
    plugins.forEach(plugin => {
      this.sensors.use(plugin)
    })

    // 页面浏览时长插件
    this.sensors.use(pageleave, {
      custom_props: {
      },
      heartbeat_interval_time: 5,
      max_duration: 5 * 24 * 60 * 60,
      isCollectUrl: function (url) {
        // url 为要采集页面浏览时长的页面地址。
        return true // 采集
        // return false; // 不采集
      }
    })

    // 页面加载时长插件
    this.sensors.use(pageload, { max_duration: 120 })

    // 12h/30min session 切割事件采集
    this.sensors.use(sessionEvent)

    // SAT - 小程序 webview 渠道归因,需与微信小程序 SDK 的 ad-channel-h5-linker 插件共同使用，不能和SiteLinker一块使用
    this.sensors.use(wechatWebviewChannel)

    // 自定义属性，通过rgpPlugin插件对指定事件注册属性
    this.rgpPlugin = this.sensors.use(rgp)
  }

  // 注册公共属性
  registerPage (properties = {}) {
    this.sensors.registerPage(rmNull(properties))
  }

  // 设置用户属性
  setProfile (properties = {}) {
    this.sensors.setProfile(rmNull(properties))
  }

  // 设置用户属性，如果不存在则设置，存在就不设置
  setOnceProfile (properties = {}) {
    this.sensors.setOnceProfile(rmNull(properties))
  }

  // 用户关联，登录后uid 会缓存在本地，后续采集的事件，均包含缓存的 ID 信息。
  loginWithKey (key, value) {
    this.sensors.loginWithKey(key, value)
  }

  // 自定义属性设置
  setProperty (events = [], properties = {}) {
    this.rgpPlugin.register({
      events,
      properties: rmNull(properties)
    })
  }

  setCache (cache = {}) {
    Object.assign(this.cache, rmNull(cache))
  }

  clearCache () {
    this.cache = {}
  }

  setPageCache (cache) {
    Object.assign(this.pageCache, rmNull(cache))
  }

  clearPageCache () {
    this.pageCache = {}
  }

 // pageShow
  pageShow (eventName, properties = {}, noExtendsReport = {}) {
    // 继承 cache
    this.sensors.track(eventName, rmNull(Object.assign({}, this.cache, properties, noExtendsReport)))
    this.clearPageCache()
    // 缓存pageCache
    this.setPageCache(rmNull(properties))
    // 初始化time
    this.time = +new Date()
  }

  // popupShow
  popupShow (eventName, properties = {}) {
    // 继承 cache
    this.sensors.track(eventName, rmNull(Object.assign({}, this.cache, properties)))
    // 初始化time
    this.popupTime = +new Date()
  }

  // 单个埋点
  track (eventName, properties = {}) {
    if (Object.keys(properties).includes('haoshi')) {
      properties.haoshi = Math.ceil(+new Date() - this.time)
    }
    // 继承 cache 和 pageCache
    this.sensors.track(eventName, rmNull(Object.assign({}, this.cache, this.pageCache, properties)))
  }

  // popup单个埋点
  popupTrack (eventName, properties = {}) {
    if (Object.keys(properties).includes('haoshi')) {
      properties.haoshi = Math.ceil(+new Date() - this.popupTime)
    }
    // 继承 cache 和 pageCache
    this.sensors.track(eventName, rmNull(Object.assign({}, this.cache, this.pageCache, properties)))
  }
}
